<template>
    <div class="popup" v-cloak v-if="isShow">
        <div class="content" id="emailFilterOption">
            <div class="title">
                <span>{{$t('language.common.emailFilter')}}</span>
                <div class="icon white-close dialog-close" @click="close()"></div>
            </div>
            <el-scrollbar style='height: calc(100% - 90px);'>
                <div class="popup-content">
                    <div class="popup-tip-title">{{$t('language.emailTransfer.filterTitle')}}</div>
                    <hr>
                    <div class="popup-option">
                        <tags-input class="filter-muli-tags filter-muli-tag-from" ref="filterFromEmails" v-model="filterFromEmails" :message="$t('language.emailTransfer.filterMessage')" :type="'filter'" :title="$t('language.common.from')+': '"></tags-input>
                    </div>
                    <hr>
                    <div class="popup-option">
                        <tags-input class="filter-muli-tags filter-muli-tag-to" ref="filterToEmails" v-model="filterToEmails" :message="$t('language.emailTransfer.filterMessage')" :type="'filter'" :title="$t('language.common.to')+': '"></tags-input>
                    </div>
                    <hr>
                    <div class="popup-option" style="width: max-content;">
                        <date-select ref="dateSelect" :selectOption="optionDates" @changeOption='onChangeDateOption' @chickOption='onCheckDateOption' :selectId="selectDateId" :title="$t('language.common.date')+':'"></date-select>
                        <hr>
                        <div class="filter-options-date" v-if="selectDateId==6&&showDatePage">
                            <div class="filter-option-date">
                                <date-picker ref="dateStart" v-model="temp.dateStart" :format="'timestamp'" :placeholder="$t('language.emailTransfer.startDate')" :inputTitle="$t('language.emailTransfer.startDate')"></date-picker>
                                <div>一</div>
                                <date-picker ref="dateEnd" v-model="temp.dateEnd" :format="'timestamp'" :placeholder="$t('language.emailTransfer.endDate')" :inputTitle="$t('language.emailTransfer.endDate')"></date-picker>
                            </div>
                            <div style="text-align: right;"><button @click="saveDate()" :class="temp.dateEnd||temp.dateStart?'':'button-disable'" :disabled="!(temp.dateEnd||temp.dateStart)"><span>{{$t('language.common.apply')}}</span></button></div>
                        </div>
                    </div>
                    <div class="popup-option" style="display:flex;height: 140px;">
                        <div class="filter-option">
                            <div class="icon-util" :class="isHasAtt?'check-small':'nocheck-small-blue'" @click="isHasAtt=!isHasAtt"></div>
                            <div>{{$t('language.emailTransfer.filterOption4')}}</div>
                        </div>
                        <div class="filter-option">
                            <div class="icon-util" :class="isUnread?'check-small':'nocheck-small-blue'" @click="isUnread=!isUnread"></div>
                            <div>{{$t('language.emailTransfer.filterOption5')}}</div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
            <div class="popup-footer">
                <button @click="reset()" style="background: rgba(80,101,187,0);border: 1px solid #B3BCF6;color:#5166BD;margin-right: 10px;"><span>{{$t('language.common.reset')}}</span></button>
                <button @click="save()"><span>{{$t('language.common.save')}}</span></button>
            </div>
        </div>
    </div>
</template>
<script>
import commonstate from '@/js/constant.js';
import tagsInput from '@/components/common/input/tag_input';
import dateSelect from '@/components/common/select/default_select';
import datePicker from '@/components/common/calendar/calendar';
export default {
    name: "emailTransferFilterOptionPopup",
    components: {
        tagsInput,
        dateSelect,
        datePicker,
    },
    data() {
        return {
            isShow: false,
            filterFromEmails: [],
            filterToEmails: [],
            selectDateId: 1,
            optionDates: [{
                    name: this.$t('language.emailTransfer.filterDateOptions1'),
                    id: 1
                },{
                    name: this.$t('language.emailTransfer.filterDateOptions2'),
                    id: 2
                },{
                    name: this.$t('language.emailTransfer.filterDateOptions3'),
                    id: 3
                },{
                    name: this.$t('language.emailTransfer.filterDateOptions4'),
                    id: 4
                },{
                    name: this.$t('language.emailTransfer.filterDateOptions5'),
                    id: 5
                },{
                    name: this.$t('language.emailTransfer.filterDateOptions6'),
                    id: 6
                }
            ],
            isHasAtt: false,
            isUnread: false,
            temp: {
                dateStart: null,
                dateEnd: null,
            },
            dateStart: "",
            dateEnd: "",
            showDatePage: true,
            saveData: {
                from: [],
                to: [],
                selectDateId: 1,
                after: null,
                before: null,
                older: null,
                isHasAtt: false,
                isUnread: false,
            }
        }
    },
    mounted() {
    },
    methods: {
        init() {
            //恢复已保存数据
            this.filterFromEmails = this.saveData.from;
            this.filterToEmails = this.saveData.to;
            this.isHasAtt = this.saveData.isHasAtt;
            this.isUnread = this.saveData.isUnread;
            this.selectDateId = this.saveData.selectDateId;
            if(this.selectDateId==6){
                this.dateStart = this.saveData.after;
                this.dateEnd = this.saveData.before;
            }else{
                this.dateStart = "";
                this.dateEnd = "";
                this.temp = {
                    dateStart: null,
                    dateEnd: null,
                }
            }
            this.isShow = true;
        },
        close() {
            this.isShow = false;
        },
        onCheckDateOption(item) {
            if(6==item){
                this.showDatePage = true;
            }
        },
        onChangeDateOption(item) {
            this.selectDateId = item;
        },
        reset() {
            this.filterFromEmails = [];
            this.filterToEmails = [];
            if(this.$refs.dateSelect){
                this.$refs.dateSelect.currentIndex = 1;
            }
            this.isHasAtt = false;
            this.isUnread = false;
            this.temp = {
                dateStart: null,
                dateEnd: null,
            }
            this.dateStart = "";
            this.dateEnd = "";
            //覆盖保存信息
            this.save();
        },
        saveDate() {
            this.dateStart = this.$refs.dateStart.value/1000;
            this.dateEnd = this.$refs.dateEnd.value/1000;
            this.showDatePage = false;
        },
        save() {
            let regEmail =commonstate.emailpattern;
            let isEmailError = false;
            this.filterFromEmails.forEach(function(e,index){
                if(!regEmail.test(e.email.trim())){
                    e.status = 'error';
                    isEmailError = true;
                }
            })
            this.filterToEmails.forEach(function(e,index){
                if(!regEmail.test(e.email.trim())){
                    e.status = 'error';
                    isEmailError = true;
                }
            })
            if(isEmailError){
                this.$toast({
                    text: this.$t('language.popup.cloudExploerPopup.emailSentNotice'),
                    type: 'fail',
                    idValue: "emailFilterOption"
                });
                return;
            }
            this.saveData.from = this.filterFromEmails;
            this.saveData.to = this.filterToEmails;
            this.saveData.isHasAtt = this.isHasAtt;
            this.saveData.isUnread = this.isUnread;
            this.saveData.selectDateId = this.selectDateId;
            if(this.selectDateId==6){
                this.saveData.after = this.dateStart;
                this.saveData.before = this.dateEnd;
                this.saveData.older = null;
            }else {
                this.saveData.after = null;
                this.saveData.before = null;
                switch (this.selectDateId) {
                    case 2:
                        //一周
                        this.saveData.older = "7d";
                        break;
                    case 3:
                        //一月
                        this.saveData.older = "1m";
                        break; 
                    case 4:
                        //六月
                        this.saveData.older = "6m";
                        break;
                    case 5:
                        //一年
                        this.saveData.older = "1y";
                        break;
                    default:
                        this.saveData.older = null;
                        break;
                }
            }
            this.close();
        },
        getFilterRule() {
            let rule = {
                gmail: this.getGmailFilterRule(),
                outlook: this.getOutlookFilterRule(),
            }
            return JSON.stringify(rule);
        },
        getGmailFilterRule() {
            //包含发件人邮件
            var fromFilter = "";
            if(this.saveData.from){
                let fromArr = this.saveData.from;
                for(let i=0;i<fromArr.length;i++){
                    fromFilter += " from:"+fromArr[i].email;
                }
                if(fromArr.length>1){
                    fromFilter = "{ "+fromFilter+" }";
                }
            }

            //包含收件人邮件
            var toFilter = "";
             if(this.saveData.to){
                let toArr = this.saveData.to;
                for(let i=0;i<toArr.length;i++){
                    toFilter += " to:"+toArr[i].email;
                }
                if(toArr.length>1){
                    toFilter = "{ "+toFilter+" }";
                }
            }

            //日期过滤规则
            var dateOlderFilter = "";
            if(this.saveData.older){
                dateOlderFilter += " older_than:"+this.saveData.older;
            }
            if(this.saveData.after){
                dateOlderFilter += " after:"+this.saveData.after;
            }
            if(this.saveData.before){
                dateOlderFilter += " before:"+this.saveData.before;
            }

            //条件过滤规则
            var hasFilter = "";
            if(this.saveData.isHasAtt){
                hasFilter = " has:attachment";
            }
            var isFilter = "";
            if(this.saveData.isUnread){
                isFilter = " is:unread";
            }

            let filterString = fromFilter+" "+toFilter+dateOlderFilter+hasFilter+isFilter;
            if(filterString.trim().length>0){
                return filterString;
            }else{
                return null;
            }
        },
        getOutlookFilterRule() {
            //包含发件人邮件
            var fromFilter = "";
            if(this.saveData.from.length>0){
                let fromArr = this.saveData.from;
                fromFilter = "AND from:(";
                for(let i=0;i<fromArr.length;i++){
                    fromFilter += " "+fromArr[i].email;
                }
                fromFilter += ") ";
            }

            //包含收件人邮件
            var toFilter = "";
             if(this.saveData.to.length>0){
                let toArr = this.saveData.to;
                toFilter = "AND to:(";
                for(let i=0;i<toArr.length;i++){
                    toFilter += " "+toArr[i].email;
                }
                toFilter += ") ";
            }

            //日期过滤规则
            var dateOlderFilter = "";
            if(this.saveData.older){
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth()+1;
                let day = date.getDate();
                switch (this.selectDateId) {
                    case 2:
                        //一周
                        day = day - 7;
                        break;
                    case 3:
                        //一月
                        month = month - 1;
                        break; 
                    case 4:
                        //六月
                        month = month - 6;
                        break;
                    case 5:
                        //一年
                        year = year - 1;
                        break;
                    default:
                        this.saveData.older = null;
                        break;
                }
                let lastTime = new Date(year, month, day);
                dateOlderFilter += "AND received>="+lastTime.getFullYear()+"-"+lastTime.getMonth()+"-"+lastTime.getDate()+" ";
            }
            if(this.saveData.after){
                let afterTime = new Date(this.saveData.after*1000);
                dateOlderFilter += "AND received>="+afterTime.getFullYear()+"-"+(afterTime.getMonth()+1)+"-"+afterTime.getDate()+" ";
            }
            if(this.saveData.before){
                let beforeTime = new Date(this.saveData.before*1000);
                dateOlderFilter += "AND received<="+beforeTime.getFullYear()+"-"+(beforeTime.getMonth()+1)+"-"+beforeTime.getDate()+" ";
            }

            //条件过滤规则
            var hasFilter = "";
            if(this.saveData.isHasAtt){
                hasFilter = "AND hasAttachment:true ";
            }

            var isFilter = "";
            if(this.saveData.isUnread){
                isFilter = "AND isRead:false ";
            }

            let filterString = fromFilter+toFilter+dateOlderFilter+hasFilter+isFilter;
            if(filterString.length>0){
                return "\""+filterString.substring(4)+"\"";
            }else{
                return null;
            }
        }
    }
}
</script>

<style scoped>
#emailFilterOption {
    width: 680px;/*no*/
    height: 510px;/*no*/
    font-family: Arial;
    font-weight: 400;
    color: #000000;
    font-size: 14px;/*no*/
    line-height: 21px;/*no*/ 
}

.popup-content {
    padding: 20px;/*no*/
    position: relative;
}

.popup-option {
    line-height: 30px;/*no*/
}

.popup-option span{
    margin: 0 10px;/*no*/
}

.popup-content hr {
    height: 1px;/*no*/ 
    background: #EFF5FD;
    border: 0 solid rgba(0,0,0,0);
    margin: 12px 0;/*no*/ 
}

.filter-muli-tags {
    max-height: 40px;/*no*/ 
    min-height: 32px;/*no*/ 
    border: 0 !important;
}

.filter-option {
    display: flex;
    margin-right: 40px;/*no*/ 
}

.filter-option .icon-util{
    margin: 8px 12px 8px 0;/*no*/
    cursor: pointer; 
}

.popup-footer {
    position: absolute;
    right: 20px;/*no*/ 
    bottom: 20px;/*no*/ 
}

.filter-options-date button,.popup-footer button{
    min-width: 110px;/*no*/
    height: 30px;/*no*/
    border-radius: 6px;/*no*/
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;/*no*/
}

.filter-options-date {
    padding: 20px;
    border: 1px solid #8A96E3;
    position: absolute;
    background: #ffffff;
}

.filter-option-date {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}

.button-disable {
    background: gray;
    cursor: no-drop;
}

</style>

<style>
.filter-muli-tags .textTitle {
    font-weight: bold;
    line-height: 30px;/*no*/ 
    margin: 0 10px;/*no*/ 
}

.filter-muli-tags .textbg {
    position: unset !important;
    float: left;
}

.filter-muli-tags input {
    line-height: 32px;/*no*/ 
}

.filter-muli-tag-from .btn{
    background: #E6F1FD !important;
    font-family: Helvetica;
    color: #2D7CE6 !important;
    font-size: 14px;/*no*/ 
}

.filter-muli-tag-to .btn{
    background: #DEF0E9 !important;
    font-family: Helvetica;
    color: #299B6A !important;
}

.filter-muli-tags .tag-input-delet-icon {
    position: absolute;
    right: -10px;/*no*/ 
    top: -8px;/*no*/ 
}

.filter-muli-tags .select-box {
    border: 0 !important;
}

.filter-muli-tags .muli-tags {
    max-height: max-content !important;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/email_transfer_popups/filter_option_popup.vue